import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'companySizes';
export const companySizesActions = makeActions(MODEL_NAME,'id','company-sizes');

export const getAllCompanySizes = companySizesActions.getAll;
export const editCompanySizes = companySizesActions.edit;
export const createCompanySizes = companySizesActions.create;
export const getByIdCompanySizes = companySizesActions.getDataById;
